import { SplashDTO } from '../types';
import { shouldDisplaySplash } from '../rules/visibility';
import { SplashService } from '../services/SplashService';

export const fetchDisplayableSplash = async (
  userId: string,
  profileId: number
): Promise<SplashDTO | null> => {
  try {
    const splash = await new SplashService().getSplash(userId);

    return shouldDisplaySplash({ splash, profileId }) ? splash : null;
  } catch {
    return null;
  }
};

export const dismissSplash = async (splashId: number, userId: string): Promise<void> => {
  try {
    await new SplashService().markSplashNotAccepted(splashId, userId);
  } catch {
    return;
  }
};
